interface SubTitleProps {
    subTitle: string
    className?: string
}

export const SubTitle = ({
    subTitle,
    className
}: SubTitleProps): JSX.Element => {
    return (
        <h2 className={`text-2xl font-bold text-black ${className}`}>
            {subTitle}
        </h2>
    )
}
